export var RolesPermissionsType;
(function (RolesPermissionsType) {
    RolesPermissionsType["MANAGE_TOURNAMENTS"] = "manage_tournaments";
    RolesPermissionsType["MANAGE_PLAYERS"] = "manage_players";
    RolesPermissionsType["HIDE_TOURNAMENTS"] = "hide_tournaments";
    RolesPermissionsType["DELETE_TOURNAMENTS"] = "delete_tournaments";
    RolesPermissionsType["DELETE_PLAYERS"] = "delete_players";
    RolesPermissionsType["IMPORT_PLAYERS"] = "import_players";
    RolesPermissionsType["POST_PODS"] = "post_pods";
    RolesPermissionsType["VIEW_STANDINGS"] = "view_standings";
    RolesPermissionsType["SET_TICK"] = "set_tick";
    RolesPermissionsType["SET_CONFIRMATION_TICK"] = "set_confirmation_tick";
    RolesPermissionsType["VIEW_QR_CODE"] = "view_qr_code";
    RolesPermissionsType["WRITE_EMAIL"] = "write_email";
    RolesPermissionsType["ASSIGN_PERMISSIONS"] = "assign_permissions";
})(RolesPermissionsType || (RolesPermissionsType = {}));
